import React, { useState } from "react";
import { Form , Button , Radio ,Row ,Col , DatePicker , Typography , Table, Tooltip} from 'antd';
import { getRangeOptions } from './reports.module';
import { fetchPassengerInfoSheet} from './../../actions/reports.action';
import { getAPIDateFormat , getLocalDateAndTime } from './../../utils/date.utils';
import { isValidArray } from "../../utils/utilities";
import {  divideFloatingPoints as DFP, roundNumber} from './../../utils/math.utils';
import { Printer } from './../../components/custom-components/custom-component';
import { getJsonKeys } from './../../utils/utilities';
import { getPaginationDetails, getDefaultPageSize } from './reports.module';
import * as XLSX from 'xlsx';


const {Text} =Typography;

const { RangePicker } = DatePicker;
let allowedMaxDaysRange=31;
let xs=24, sm=24, md=12 , lg=12 , xl=12 , xxl=12;



const generateJsonToExport=(filters,passengerInfo)=>{

    let reportsXmlData=[];
    if(isValidArray(passengerInfo)&&passengerInfo.length>0){
        passengerInfo.forEach(element => {
            let avgFare = DFP(element.totalTicketCost,element.ticketCount);
            reportsXmlData.push([
                element.phoneNumber,element.fullName,element.emailId,
                element.seatNumber || '',
                element.bookingCount || 0,element.ticketCount,
                element.formatedCoach,avgFare,element.formatedbookingSource,
                element.formatedOriginDestination
            ])
        });
    }

    let agentName=filters.isSelectAllAgents?'all':filters.agentName;
    let dateType =filters.isBookingDate?"Booking":"Travel";
    let generatedTime = getLocalDateAndTime(new Date());


        var worksheet = XLSX.utils.aoa_to_sheet([
            [], // A1
            [], // A2
            ["Report","Agents","From Date", "To Date","Type of date" , "Generated day/time"], // A3
            ["Frequent Travellers Report",agentName,filters.fromDate,filters.toDate,dateType,generatedTime],
            [],
            [],
            [
                "Phone number","Passenger name", "Email" , "Seats" , "No. of bookings" , "Total seats booked" ,
                "Bus types" , "Average fare" , "Booking source" ,
                "Origin-Destination"
            ],
            ...reportsXmlData
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Frequent Travellers Report');
        XLSX.writeFile(workbook, 'frequent-travellers-report.xlsx');
}

const validateAgent=(agentName,agentKeys)=>{
    let bool=false;

    for (let index = 0; index < agentKeys.length; index++) {
        const element = agentKeys[index];
        if(agentName===element){
            bool = true;
            break;
        }
    }

    return bool;
  
}

const getTicketsByAgentName=(tickets,agentName,isSelectAllAgents)=>{
    let formatedTickets=[], filterBookingSource = [], insertedBookingSource = [];
    if(isValidArray(tickets)){
        for (var key in tickets) {
            if (tickets.hasOwnProperty(key)) {
              var userTickets = tickets[key];
              let agentKeys=getJsonKeys(userTickets.agent);
              if(isSelectAllAgents||validateAgent(agentName,agentKeys)){
                const SEP = '\n';
                const BULLET = '• ';
                let coachParts = [];
                let originDestinationParts = [];
                let bookingSourceParts = [];
                Object.keys(userTickets.originDestination).forEach((OD)=>{
                    originDestinationParts.push(BULLET + OD + '(' + userTickets.originDestination[OD] + ')');
                })
                Object.keys(userTickets.coach).forEach((type)=>{
                    coachParts.push(BULLET + type + '(' + userTickets.coach[type] + ')');
                })
                Object.keys(userTickets.agent).forEach((name)=>{
                    if (!insertedBookingSource.includes(name)) {
                        insertedBookingSource.push(name);
                        filterBookingSource.push({text: name, value: name});
                    }
                    bookingSourceParts.push(BULLET + name + '(' + userTickets.agent[name] + ')');
                })
                    formatedTickets.push({
                        formatedCoach:coachParts.join(SEP),
                        formatedbookingSource:bookingSourceParts.join(SEP),
                        formatedOriginDestination:originDestinationParts.join(SEP),
                        phoneNumber:key,
                        ...userTickets
                    });
                }
            }
          }
    }
    formatedTickets.sort((a,b)=> (b.ticketCount || 0) - (a.ticketCount || 0));
    return {dataSource: formatedTickets, filterBookingSource};
}


const RenderReport=({fromDate,toDate,isBookingDate,agentName,dataSource,pagination,isSelectAllAgents, filterBookingSource})=>{

    const [page, setPage] = useState(1);
    const [paginationSize, setPaginationSize] = useState(getDefaultPageSize);

    const ellipsisCell = (text) => (
        <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
        </Tooltip>
    );

const passengerTicketsInfoColumns=[
        {
            title:'SN',
            key:'index',
            width: 45,
            render : (text, record, index) => (page - 1) * paginationSize + index+1
        },
        {
            title:'Phone',
            key:'phoneNumber',
            dataIndex : 'phoneNumber',
            width: 115,
            render : (text,record) => {
                let value = isValidArray(text) ? text[0] : text;
                return <span className="ft-num">{value}</span>;
            }
        },
        {
            title:'Passenger',
            key:'fullName',
            dataIndex:'fullName',
            width: 110,
            ellipsis: { showTitle: false },
            render: ellipsisCell
        },
        {
            title:'Email',
            key:'Email',
            dataIndex : 'emailId',
            width: 170,
            ellipsis: { showTitle: false },
            render: ellipsisCell
        },
        {
            title:'Seats',
            key:'seatNumber',
            dataIndex : 'seatNumber',
            width: 130,
            className: 'ft-wrap',
            render: (text) => <span className="ft-wrap-text">{text || '-'}</span>
        },
        {
            title:'Bookings',
            key:'bookingCount',
            dataIndex : 'bookingCount',
            width: 90,
            align: 'center',
            sorter: (a,b)=> (a.bookingCount || 0) - (b.bookingCount || 0),
            render: (text) => <span className="ft-pill ft-pill-info">{text || 0}</span>
        },
        {
            title:'Seats Booked',
            key:'ticketCount',
            dataIndex : 'ticketCount',
            width: 100,
            align: 'center',
            defaultSortOrder: 'descend',
            sorter: (a,b)=> (a.ticketCount || 0) - (b.ticketCount || 0),
            render: (text) => <span className="ft-pill ft-pill-accent">{text || 0}</span>
        },
        {
            title:'Trip Description',
            key:'formatedCoach',
            dataIndex : 'formatedCoach',
            width: 200,
            className: 'ft-wrap',
            render: (text) => <span className="ft-wrap-text">{text}</span>
        },
        {
            title:'Avg Fare',
            key:'Average fare',
            width: 85,
            align: 'right',
            render : (text, record, index) => (
                <span className="ft-num">{roundNumber(DFP(record.totalTicketCost,record.ticketCount))}</span>
            )
        },
        {
            title:'Booking Source',
            key:'formatedbookingSource',
            dataIndex : 'formatedbookingSource',
            width: 150,
            className: 'ft-wrap',
            filters: filterBookingSource,
            onFilter: (value, record) => (record.formatedbookingSource || '').indexOf(value) !== -1,
            render: (text) => <span className="ft-wrap-text">{text}</span>
        },
        {
            title:'Route',
            key:'formatedOriginDestination',
            dataIndex : 'formatedOriginDestination',
            width: 160,
            className: 'ft-wrap',
            render: (text) => <span className="ft-wrap-text">{text}</span>
        }
    ];
    

    return(
        <div className="frequent-travellers-report">
            <Row justify="center" gutter={[16,16]}>
                <Col>
                    <Text strong>Frequent Travellers Report</Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>From date : </Text>{fromDate}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>To date : </Text>{toDate}
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>Type of date : </Text>{isBookingDate?"Booking Date":"Travel Date"}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                            <Text strong>Generated day/time : </Text>{getLocalDateAndTime(new Date())}
                    </Text> 
                </Col>
            </Row>
            <Row gutter={[16,0]}>
                <Col>
                    <Text strong>Agent : {isSelectAllAgents?"All agents":agentName}</Text>
                </Col>
            </Row>
           <Row gutter={[16,16]} className="marginTop">
               <Col span={24}>
                <Table
                        className="ft-table"
                        columns={passengerTicketsInfoColumns}
                        dataSource={dataSource}
                        rowKey={(record, index) => `${record.phoneNumber || ''}-${index}`}
                        size="middle"
                        scroll={{ x: 1350 }}
                        pagination={getPaginationDetails(pagination,setPage, paginationSize, setPaginationSize)}
                    />
               </Col>
           </Row>
        </div>
    )
}

export const ViewPassengersInfoReport = () => {

    const [form] = Form.useForm();

    const [showReport,setShowReport]=useState(false);
    const [filters,setFilters]=useState({
        fromDate:undefined,
        toDate:undefined,
        isSelectAllAgents:true,
        agentNames:[]
    });
    const [passengerInfo,setPassengerInfo]=useState(undefined);

    const onSuccess=(data)=>{
        setPassengerInfo(data.passengerStats);
        filters.agentNames=getJsonKeys(data.agentStats);
        setFilters({...filters});
        setShowReport(true);
    }

    const onFailure=()=>{
        setPassengerInfo(undefined);
        setShowReport(false);
    }

    const onFinish=(values)=>{
        let {
            dateRange,
            isBooking
        }=values;
        const fromDate = getAPIDateFormat(dateRange[0]);
        const toDate = getAPIDateFormat(dateRange[1]);
        setShowReport(false);
        filters.fromDate=fromDate;
        filters.toDate=toDate;
        filters.isBookingDate=isBooking;
        setFilters({...filters});
        fetchPassengerInfoSheet(fromDate,toDate,isBooking,onSuccess,onFailure)
    }


    let {dataSource, filterBookingSource} = getTicketsByAgentName(passengerInfo,filters.agentName,filters.isSelectAllAgents);

    return (
            <div className="report-inner-div">
                <Form
                    onFinish={onFinish}
                    form={form}
                    >
                    <Row gutter={[16,16]}>
                        <Col>
                            <Form.Item name="dateRange" label="Date range" 
                               rules={[
                                { required: true , message: 'Please input your date range!'},
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (!value || (value[1].diff(value[0],"days") <= allowedMaxDaysRange)) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(new Error(`Please select a date range with in ${allowedMaxDaysRange} days`));
                                    },
                                  })
                            ]}t>
                                    <RangePicker 
                                        ranges={getRangeOptions(allowedMaxDaysRange)} 
                                    />
                            </Form.Item>
                        </Col>
                        <Col>
                        <Form.Item name="isBooking" label="" rules={[{ required: true , message: 'Please select any option!'}]}>
                            <Radio.Group>
                                <Radio value={true}>Booking Date</Radio>
                                <Radio value={false}>Travel Date</Radio>
                            </Radio.Group>
                        </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item>
                                <Button htmlType="submit">Search</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {showReport&&
                <div>
                    <Row gutter={16}>
                        <Col>
                              <Button onClick={()=>{
                                   generateJsonToExport(filters,dataSource);
                                }}>Export</Button>
                        </Col>
                        <Col>        
                        <Printer 
                            showComponent={false}
                            zoomValue={0.8}
                            renderComponent={()=>{
                                return (
                                    <RenderReport 
                                        fromDate={filters.fromDate}
                                        toDate={filters.toDate}
                                        isBookingDate={filters.isBookingDate}
                                        agentName={filters.agentName}
                                        isSelectAllAgents={filters.isSelectAllAgents}
                                        dataSource={dataSource}
                                        pagination={false}
                                    />
                            )
                        }} />
                        </Col>
                    </Row>
                    <RenderReport 
                        fromDate={filters.fromDate}
                        toDate={filters.toDate}
                        isBookingDate={filters.isBookingDate}
                        agentName={filters.agentName}
                        isSelectAllAgents={filters.isSelectAllAgents}
                        dataSource={dataSource}
                        pagination={true}
                        filterBookingSource = {filterBookingSource}
                    />
                </div>
                }
            </div>
    )
}